import React, { useEffect, useState } from 'react';
import { Grid, Box } from '@mui/material';

import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import ModalHeader from '../../CustomModal/ModalHeader';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import * as _ from 'lodash';
import CustomDatePicker from '../../../components/CustomDatePicker/CustomDatePicker';
import CustomAutoComplete from '../../../components/CustomAutoComplete/CustomAutoComplete';
import moment from 'moment';

import { fonts, themes } from '../../../themes/themes';
import DropAndSelect from '../../../components/DropAndSelect/DropAndSelect';
import { AnyAaaaRecord } from 'dns';
import { toast } from 'react-hot-toast';
import Compdirection from '../../../themes/CompDirection';
interface ModalProps {
  isModalOpen?: boolean;
  closeModal: any;
  allInsurerTypes: any;
  allPolicyTypes: any;
  callBackGetData: (data: any) => void;
  editedData: any;
  trans?: any;
}

const EditInsurancePresenter = ({
  isModalOpen,
  closeModal,
  callBackGetData,
  allInsurerTypes,
  allPolicyTypes,
  editedData,
  trans,
}: ModalProps) => {
  const [amount, setAmount] = useState(editedData?.amount);
  const [policyNumber, setPolicyNumber] = useState(editedData?.policy_number);

  const [category, setCategory] = useState(editedData?.category);

  const [policyTypeName, setPolicyTypeName] = useState(
    editedData?.policytype?.name,
  );
  const [policyTypeId, setPolicyTypeId] = useState(editedData?.policytype?.id);

  const [insurerTypeName, setInsurerTypeName] = useState(
    editedData?.insurers?.name,
  );
  const [insurerTypeId, setInsurerTypeId] = useState(editedData?.insurers?.id);
  const [removeImage, setRemoveImage] = useState(false);
  const [startDate, setStartDate] = useState<any>(editedData.start_date);
  const [endDate, setEndDate] = useState<any>(editedData.expiry_date);

  const [insuranceDocuments, setInsuranceDocuments] = useState(
    editedData?.dependent_insurance_documents[0]?.document,
  );
  const [insuranceDocumentsPath, setInsuranceDocumentsPath] = useState(
    editedData?.dependent_insurance_documents[0]?.document,
  );
  const [newattachement, setNewAttachement] = useState(false);
  const [isPDF, setIsPDF] = useState<boolean>(false);
  const [pdfName, setPDFName] = useState('');

  const insuranceDocumentsUpload = (e: any) => {
    const file: any = e.target.files[0];
    setNewAttachement(true);
    if (file?.type.includes('image')) {
      const image_as_base64 = URL.createObjectURL(e.target.files[0]);
      const image_as_files: any = file;

      setInsuranceDocuments(image_as_files);
      setInsuranceDocumentsPath(image_as_base64);
    } else {
      setIsPDF(true);
      setPDFName(file?.name);
      setInsuranceDocuments(file);
    }
  };
  const handleInsurerType = (insurerName: any) => {
    const getInsurer = _.filter(allInsurerTypes, function (insurer: any) {
      return insurer.name === insurerName;
    });
    if (getInsurer.length) {
      const insurer_type = getInsurer[0];
      setInsurerTypeId(insurer_type.id);
      setInsurerTypeName(insurerName);
    }
  };

  const handlePolicyType = (policyName: any) => {
    const getPolicy = _.filter(allPolicyTypes, function (policy: any) {
      return policy.name === policyName;
    });
    if (getPolicy.length) {
      const policy_type = getPolicy[0];
      setPolicyTypeId(policy_type.id);
      setPolicyTypeName(policyName);
    }
  };
  const handleSubmit = () => {
    if (new Date(startDate) > new Date(endDate)) {
      toast.error(trans('End date must be greater than start date!'));
    } else {
      callBackGetData({
        id: editedData?.id,
        insurer: insurerTypeId,
        policy_type: policyTypeId,
        policy_number: policyNumber,
        start_date: startDate,
        end_date: endDate,
        category: category,
        amount: amount,
        attachments: insuranceDocuments,
        newattachement: newattachement,
        removed: removeImage ? removeImage : '',
      });
      closeModal();
    }
  };

  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="687px"
      modalWidth="550px"
    >
      <ModalHeader
        modal={{ modal_title: trans('Edit Insurance') }}
        closeModal={closeModal}
      />
      <Compdirection>
        <Grid
          container
          spacing={3}
          style={{
            marginTop: '35px',
          }}
        >
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Insure')}
              options={_.map(allInsurerTypes, (insurer: any) => {
                return insurer.name;
              })}
              value={insurerTypeName}
              onChange={(event: any, newValue: any) => {
                handleInsurerType(newValue);
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomAutoComplete
              label={trans('Policy Type')}
              options={_.map(allPolicyTypes, (policy: any) => {
                return policy.name;
              })}
              value={policyTypeName}
              onChange={(event: any, newValue: any) => {
                handlePolicyType(newValue);
              }}
            />
          </Grid>

          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Policy Number')}
              placeholder={trans('Write Policy Number')}
              value={policyNumber}
              onChange={(e: any) => setPolicyNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomTextField
              type="string"
              label={trans('Category')}
              placeholder={trans('Write Category')}
              value={category}
              onChange={(e: any) => setCategory(e.target.value)}
            />
          </Grid>

          <Grid item xs={6}>
            <CustomDatePicker
              label={trans('Start Date')}
              value={startDate}
              onChange={(newValue: any) => {
                setStartDate(moment(newValue?.$d).format('YYYY-MM-DD'));
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <CustomDatePicker
              label={trans('End Date')}
              value={endDate}
              onChange={(newValue: any) => {
                setEndDate(moment(newValue?.$d).format('YYYY-MM-DD'));
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <CustomTextField
              type="number"
              label={trans('Amount')}
              placeholder={trans('Write Amount')}
              value={amount}
              onChange={(e: any) => setAmount(e.target.value)}
            />
          </Grid>

          <Grid item xs={5}>
            <DropAndSelect
              upload={insuranceDocumentsUpload}
              src={insuranceDocumentsPath}
              onDelete={() => {
                setInsuranceDocumentsPath('');
                setNewAttachement(false);
                setRemoveImage(true);
              }}
            />
          </Grid>
        </Grid>
      </Compdirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        onClickSubmit={() => handleSubmit()}
        onClickCancel={() => {
          closeModal();
        }}
      />
    </CustomModal>
  );
};

export default EditInsurancePresenter;
